// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { number, string, boolean } from "@altostra/type-validations/lib/primitives";

export const isAppsTransformationsDatatableResult = objectOf({
  id: string,
  url: string,
  name: string,
  approval_status: string,
  updated_at: string,
  total_run_count: number,
  success_run_count: number,
  is_javascript: boolean,
  activation_available: boolean,
  endpoint: string,
});
